import styled from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';

export const StyledTranscriptBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 100%;
  max-height: 36rem;
  overflow-y: auto;
  padding: 1.5rem;
`;

export const StyledLoaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 20rem;
`;

export const StyledMessage = styled.div<{ $isUser?: boolean; $background?: string; $color?: string }>`
  align-self: ${({ $isUser }) => ($isUser ? 'flex-end' : 'flex-start')};
  background: ${({ $isUser, $background }) => ($isUser ? ($background ?? COLORS.BLUE_MAIN) : COLORS.GRAY_1)};
  color: ${({ $isUser, $color }) => ($isUser ? ($color ?? COLORS.WHITE) : COLORS.TEXT_PRIMARY)};
  padding: 0.625rem 0.875rem;
  border-radius: 0.75rem;
  max-width: 70%;
  ${pickThemeFontStyles('14', '24')}
  text-wrap-style: pretty;
  font-family: var(--font-figtree);

  p {
    margin: 0;
    white-space: pre-wrap;
  }

  ul,
  ol {
    margin-block: 1em;
  }

  a {
    color: inherit;
    text-decoration: underline;
  }
`;
